import apiClient from "./apiClient";
import { TripData, AvailabilityData, VehicleResponse } from "@/types";
import { getArgentinaDate, getArgentinaTomorrowDate } from "@/utils/dateUtils";

// Servicios para los viajes
export const tripService = {
  startTrip: async (tripData: any) => {
    return apiClient.post("/trips/start", tripData);
  },
  endTrip: async (tripData: any) => {
    return apiClient.post("/trips/end", tripData);
  },
  getTrips: async (driverId?: string | number) => {
    const endpoint = driverId
      ? `/shipments/driver/${driverId}`
      : "/me/shipments";
    return apiClient.get(endpoint);
  },
  reportAvailability: async (availabilityData: any) => {
    return apiClient.post("/availabilities", availabilityData);
  },
  getDriverAvailability: async () => {
    return apiClient.get("/me/availabilities");
  },
  getUserScope: async () => {
    return apiClient.get("/me/scope");
  },
  getMyProfile: async () => {
    return apiClient.get("/me/profile");
  },
  getTodayShipment: async () => {
    const today = getArgentinaDate(); // Fecha en zona horaria de Argentina
    return apiClient.get(`/me/shipments?date=${today}`);
  },
  getTomorrowShipment: async () => {
    const tomorrow = getArgentinaTomorrowDate(); // Fecha de mañana en zona horaria de Argentina
    return apiClient.get(`/me/shipments?date=${tomorrow}`);
  },
  getMyCoordinations: async (date: string) => {
    return apiClient.get(`/me/coordinations?date=${date}`);
  },
  startShipment: async (
    shipmentId: string,
    shipmentData: {
      attended: boolean;
      status: string;
      routeId: string;
      vehiclePlate: string;
      packages: number;
    }
  ) => {
    return apiClient.put(`/shipments/${shipmentId}`, shipmentData);
  },
  endShipment: async (
    shipmentId: string,
    shipmentData: {
      routeCompleted?: boolean;
      status: string;
      comment?: string;
      missingPackages?: number | null;
      failedPackages?: number | null;
    }
  ) => {
    return apiClient.put(`/shipments/${shipmentId}`, shipmentData);
  },
  updateAvailability: async (
    availabilityId: string | number,
    availabilityData: {
      date: string;
      available: boolean;
      svcId: number;
      shift: string;
      assignedToday: boolean;
      driverId: string;
    }
  ) => {
    const endpoint = `/availabilities/${String(availabilityId)}`;
    return apiClient.put(endpoint, availabilityData);
  },
  deleteAvailability: async (availabilityId: string | number) => {
    const endpoint = `/availabilities/${String(availabilityId)}`;
    return apiClient.delete(endpoint);
  },
  /** Una sola petición y una notificación admin consolidada al borrar varias filas del mismo día. */
  deleteAvailabilitiesBulk: async (ids: Array<string | number>) => {
    return apiClient.post("/availabilities/bulk-delete", { ids });
  },
  getVehicles: async () => {
    return apiClient.get("/me/vehicles");
  },
};

export default apiClient;
